

export class EmployeeIncrementDto implements IEmployeeIncrementDto {
    id!: number;
    employeeId!: number;
    oldSalary!: number;
    newSalary!: number;
    effectiveDate!: Date;

    constructor(data?: IEmployeeIncrementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.oldSalary = _data["oldSalary"];
            this.newSalary = _data["newSalary"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeIncrementDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeIncrementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["oldSalary"] = this.oldSalary;
        data["newSalary"] = this.newSalary;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployeeIncrementDto {
    id: number;
    employeeId: number;
    oldSalary: number;
    newSalary: number;
    effectiveDate: Date;
}

